import React from 'react'
import yn from 'yn'
import _ from 'lodash'

const BkFlowNavigationDetailsEntry = props =>  {
	const {
		currentRoomKey,
		configData,
		urlData,
		activeStep,
		flowGuestData,
		activeRoomData,
		currentRoom,
		activeEnhancementData,
		multiRoomData,
		editRoomEvent,
		removeRoomEvent,
		editStepEvent,
		removeEnhancementEvent,
		isExpanded,
	} = props

	function isEnhancementTitle(title) {
		return title.name === 'Title'
	}

	const hotelLabels = configData.hotel.labels[0]

	let stepThreshold = 1,
			renderAdults = null,
			renderChildren = null,
			renderEnhancements = [],
			roomName = '--',
			rateName = '--',
			rateCode = null

	// Update threshold if preRes services component
	if (process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) {
		stepThreshold = 2
	}

	// Assign adults from localStorage or query params
	if (
		!_.isEmpty(flowGuestData) &&
		_.get(flowGuestData, '[' + currentRoomKey + '].adults') > 0
	) {
		renderAdults = (
			<span className="u-remove-margin">
				{flowGuestData[currentRoomKey].adults} {flowGuestData[currentRoomKey].adults > 1 ? hotelLabels.adults : hotelLabels.adult}
			</span>
		)
	} else if (
		urlData &&
		urlData.adults > 0
	) {
		renderAdults = (
			<span className="u-remove-margin">
				{ urlData.adults } { urlData.adults > 1 ? hotelLabels.adults : hotelLabels.adult }
			</span>
		)
	}

	if (
		flowGuestData &&
		_.get(flowGuestData, '[' + currentRoomKey + '].children') > 0
	) {
		renderChildren = (
			<span className="u-remove-margin">
				, {flowGuestData[currentRoomKey].children} {flowGuestData[currentRoomKey].children > 1 ? hotelLabels.children : hotelLabels.child}
			</span>
		)
	} else if (urlData && urlData.children > 0) {
		renderChildren = (
			<span className="u-remove-margin">
				, { urlData.children } { urlData.children > 1 ? hotelLabels.children : hotelLabels.child}
			</span>
		)
	}

	if (currentRoom) {
		// Assign room name from activeRoom state
		if (_.get(currentRoom, '[0][0].roomDescription.name')) {
			roomName = currentRoom[0][0].roomDescription.name
		}

		// Assign rate name from activeRoom state
		if (_.get(currentRoom, '[2][0].ratePlanName')) {
			rateName = currentRoom[2][0].ratePlanName
		}

		// Assign rate code from activeRoom state
		if (_.get(currentRoom, '[2][0].ratePlanCode')) {
			rateCode = currentRoom[2][0].ratePlanCode
		}

		// Build enhancement totals
		if (!_.isEmpty(activeEnhancementData)) {

			// Loop for related enhancements by roomGroup and roomType
			for (let roomEnhancementKeys in activeEnhancementData) {
				const currentActiveEnhancement = activeEnhancementData[roomEnhancementKeys]

				if (
					Number(currentActiveEnhancement.roomGroup) === Number(currentRoomKey) &&
					currentActiveEnhancement.roomType === currentRoom[0][0].roomTypeCode
				) {
					// Gather enhancement titles
					renderEnhancements.push(
						<p
							key={ roomEnhancementKeys }
							className="u-remove-margin"
						>
							{currentActiveEnhancement.enhancementApiData.serviceDetails.comments.find(isEnhancementTitle).text}
							&nbsp;-&nbsp;
							<button
								key={roomEnhancementKeys}
								className="btn btn-text-only"
								onClick={() => removeEnhancementEvent(activeEnhancementData, roomEnhancementKeys)}
							>
								{hotelLabels.remove ? hotelLabels.remove : 'Remove'}
							</button>
						</p>
					)
				}
			}
		}
	}

	const displayEditRoomButton = isExpanded && activeStep !== 0 && activeStep <= stepThreshold

	return  (
		<div
			key={currentRoomKey}
			className={ process.env.REACT_APP_COMPONENT_NAVIGATION_DETAILS_ROOM_LAYOUT ?
				'bk-flow-navigation-details__details-entry bk-flow-navigation-details__details-entry--' + process.env.REACT_APP_COMPONENT_NAVIGATION_DETAILS_ROOM_LAYOUT
			:
				'bk-flow-navigation-details__details-entry'
			}
		>
			<div className="bk-flow-navigation-details__details-entry-heading">
				<p className="label u-remove-margin u-font-bold">{ hotelLabels.room } { currentRoomKey + 1 }</p>

				<div className="bk-flow-navigation-details__buttons">
					{ displayEditRoomButton &&
						yn(process.env.REACT_APP_COMPONENT_NAVIGATION_EDIT_ROOM_BUTTON) &&
						<button
							className="btn btn-text-only btn-xs bk-flow-navigation-details__button"
							onClick={ () => editRoomEvent(activeStep, currentRoomKey, multiRoomData) }
						>
							{ hotelLabels.edit }
						</button>
					}

					{ Number(currentRoomKey) > 0 && yn(process.env.REACT_APP_COMPONENT_NAVIGATION_REMOVE_ROOM_BUTTON) &&
						<button
							className="btn btn-text-only btn-xs btn-red bk-flow-navigation-details__button"
							onClick={ () => removeRoomEvent(activeRoomData, currentRoomKey, multiRoomData) }
							tabIndex={-1}
						>
							{ hotelLabels.remove }
						</button>
					}
				</div>
			</div>

			<div className="bk-flow-navigation-details__details-entry-row">
				<p className="label u-remove-margin u-font-bold">{ hotelLabels.room }: </p>
				<p className="value u-remove-margin">{ roomName }</p>
			</div>

			<div className="bk-flow-navigation-details__details-entry-row">
				<p className="label u-remove-margin u-font-bold">{ hotelLabels.guests }: </p>
				<p className="value u-remove-margin">
					{renderAdults}
					{renderChildren}
				</p>
			</div>

			<div className="bk-flow-navigation-details__details-entry-row">
				<p className="label u-remove-margin u-font-bold">{hotelLabels.rate}: </p>
				<p className="value u-remove-margin">
					{rateName}
					{
						yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DETAILS_RATE_FORMAT === 'label-code') &&
						rateCode &&
							' (' + rateCode + ')'
					}
				</p>
			</div>

			{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DETAILS_SERVICES) &&
				!_.isEmpty(renderEnhancements) &&
					<div className="bk-flow-navigation-details__details-entry-enhancements">
						<div className="bk-flow-navigation-details__details-entry-heading">
							<div className="label u-remove-margin u-font-bold">{ hotelLabels.enhancements }</div>
							<button
								className="u-remove-margin btn btn-text-only btn-xs bk-flow-navigation-details__button"
								onClick={ () => editStepEvent(1) }
								tabIndex={-1}
							>
								{ hotelLabels.edit }
							</button>
						</div>
						<div className="bk-flow-navigation-details__details-entry-enhancements-entries">
							{ renderEnhancements }
						</div>
					</div>
			}
		</div>
	)
}

export default BkFlowNavigationDetailsEntry


// WEBPACK FOOTER //
// ./src/components/structure/navigation/elements/BkFlowNavigationDetailsEntry.js